import React from 'react';

class Checkbox extends React.Component {
  render() {
    const { input, checkedValue, className, text, children } = this.props;
    const labelClassName = 'btn btn-outline-secondary btn-multiline' + (className ? ` ${className}` : '');
    return (
      <label
        className={labelClassName}
        htmlFor={input.name}
        onClick={_ => input.onChange(!input.value)}
      >
        <input
          name={input.name}
          type='checkbox'
          className='mr-1'
          checked={checkedValue === input.value}
        />
        {text && ` ${text}`}
        {children && children}
      </label>
    );
  }
}

export default Checkbox;


// WEBPACK FOOTER //
// ./src/components/RenderCheckbox.js